import { render, staticRenderFns } from "./companyHonor.vue?vue&type=template&id=2bdcc555&scoped=true&"
import script from "./companyHonor.vue?vue&type=script&lang=js&"
export * from "./companyHonor.vue?vue&type=script&lang=js&"
import style0 from "./companyHonor.vue?vue&type=style&index=0&id=2bdcc555&scoped=true&lang=css&"
import style1 from "./companyHonor.vue?vue&type=style&index=1&id=2bdcc555&scoped=true&lang=less&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2bdcc555",
  null
  
)

export default component.exports